import { CarouselItem } from './LandingCarouselProps.types'

export const MostPopular: CarouselItem[] = [
  {
    imgSrc: 'landingPage.mostPopularGame1',
    name: 'Sweet Bonanza',
  },
  {
    imgSrc: 'landingPage.mostPopularGame2',
    name: 'Cash Eruption',
  },
  {
    imgSrc: 'landingPage.mostPopularGame3',
    name: 'Gold Blitz Extreme-',
  },
  {
    imgSrc: 'landingPage.mostPopularGame4',
    name: 'Sugar Rush',
  },
  {
    imgSrc: 'landingPage.mostPopularGame5',
    name: 'Cleopatra',
  },
  {
    imgSrc: 'landingPage.mostPopularGame6',
    name: 'Amazing Link Zeus',
  },
  {
    imgSrc: 'landingPage.mostPopularGame7',
    name: 'Gates of Olympus 1000',
  },
  {
    imgSrc: 'landingPage.mostPopularGame8',
    name: 'Cash Machine',
  },
]

export const Jackpots: CarouselItem[] = [
  {
    imgSrc: 'landingPage.jackpotGame1',
    name: 'Gold Factory Jackpots Maple Moolah',
  },
  {
    imgSrc: 'landingPage.jackpotGame2',
    name: 'Joker Burst Frenzy Maple Moolah',
  },
  {
    imgSrc: 'landingPage.jackpotGame3',
    name: '9 Pots of Gold King Millions',
  },
  {
    imgSrc: 'landingPage.jackpotGame4',
    name: 'Fire And Roses Joker King Millions',
  },
  {
    imgSrc: 'landingPage.jackpotGame5',
    name: '9 Masks of Fire King Millions',
  },
  {
    imgSrc: 'landingPage.jackpotGame6',
    name: 'Rising Rewards King Millions',
  },
  {
    imgSrc: 'landingPage.jackpotGame7',
    name: 'Kingdom of Atlantis Jackpot Play',
  },
  {
    imgSrc: 'landingPage.jackpotGame8',
    name: 'Stone Gaze of Medusa',
  },
];

export const Classic: CarouselItem[] = [
  {
    imgSrc: 'landingPage.classicGame1',
    name: 'Blazin Ice',
  },
  {
    imgSrc: 'landingPage.classicGame2',
    name: 'Juicy Reels',
  },
  {
    imgSrc: 'landingPage.classicGame3',
    name: '7s Wild',
  },
  {
    imgSrc: 'landingPage.classicGame4',
    name: 'Cash Money',
  },
  {
    imgSrc: 'landingPage.classicGame5',
    name: 'Break Da Bank',
  },
  {
    imgSrc: 'landingPage.classicGame6',
    name: 'Blazin Gems',
  },
  {
    imgSrc: 'landingPage.classicGame7',
    name: 'Golden Winner',
  },
  {
    imgSrc: 'landingPage.classicGame8',
    name: 'Triple Gold Bars',
  },
]
